import { forwardRef, ForwardedRef } from 'react';
import { Flex, Box, Text, useTab, TabProps } from '@chakra-ui/react';

export const CustomTab = forwardRef(
  (props: TabProps, ref: ForwardedRef<HTMLElement>): JSX.Element => {
    const tabProps = useTab({ ...props, ref });
    const isSelected = !!tabProps['aria-selected'];
    const colCount = tabProps['aria-colcount'] || 1;
    const width = 100 / colCount;

    return (
      <Flex
        direction="column"
        cursor="pointer"
        width={`${width}%`}
        _focus={{ border: 'none', outline: 'none' }}
        {...tabProps}
      >
        <Text
          textStyle="body"
          align="center"
          color={isSelected ? 'custom.levoBlack' : 'custom.levoGray'}
          mb={1}
          mt={2}
        >
          {tabProps.children}
        </Text>
        <Box
          height="6px"
          bg={isSelected ? 'custom.levoYellow' : 'transparent'}
        />
      </Flex>
    );
  },
);

export default CustomTab;
